import { render, staticRenderFns } from "./QuestionDate.vue?vue&type=template&id=dc9a6d86&scoped=true&"
import script from "./QuestionDate.vue?vue&type=script&lang=js&"
export * from "./QuestionDate.vue?vue&type=script&lang=js&"
import style0 from "./QuestionDate.vue?vue&type=style&index=0&id=dc9a6d86&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc9a6d86",
  null
  
)

export default component.exports